import React from 'react';
import Link from 'next/link';
import Container from 'react-bootstrap/Container';

const EmptyCart = () => {

    return (
        <Container className="d-flex flex-column align-items-center justify-content-center h-100">
            <h1 className="heading2 pt-3 font-weight-bold black-text pb-0">Coșul tău este gol</h1>
            <p>
                Pentru a adăuga produse în coș, te rugăm să te întorci în comparator.
            </p>
            <Link
                href="/asigurari-rca/compara"
                title="Comparații RCA"
                className="btn btn-primary">
                
                    Comparații RCA
                
            </Link>
        </Container>
    );
}

export default EmptyCart;